//@ts-nocheck
import ReactGA from "react-ga4";
import { useEffect } from "react";

// innovate's dev GA tag: const MEASUREMENT_ID = "G-WEG63MNSG9";
const MEASUREMENT_ID = "G-YMZCGJEFE1";

const TRACKING_CONFIG = {
	feedback_menu_buttons: {
		event: "feedback_menu_buttons",
		param: "feedback_menu_buttons_click",
	},
	right_panel: {
		event: "panel_right_tabs",
		param: "panel_right_tabs_click",
	},
	left_panel: {
		event: "panel_left_tabs",
		param: "panel_left_tabs_click",
		transform: (value: number) =>
			({
				0: "explore",
				1: "prioritize",
				2: "evaluate",
			}[value]),
	},
	export_map: {
		event: "export_map",
		param: "export_map_click",
	},
	export_map_pdf: {
		event: "export_map_pdf",
		param: "export_map_download",
	},
	export_statistics_click: {
		event: "export_statistics",
		param: "export_statistics_click",
		//transform: (region: string) => `${region}_export_statistics_click`,
	},
	export_statistics_pdf: {
		event: "export_statistics_pdf",
		param: "export_statistics_download",
		//transform: (region: string) => `${region}_export_statistics_download`,
	},
	park_click: {
		event: "park_click",
		params: {
			park_click_name: "park_click_name",
			park_click_geography: "park_click_geography",
		},
	},
	address_search: {
		event: "city_address_search",
		param: "city_address_search_geography",
	},
	city_search: {
		event: "city_search",
		param: "city_search_geography",
	},
	city_page: {
		event: "city_page",
		param: "city_page_geography",
	},
	layer_toggle: {
		event: "explore_layer_toggle",
		param: "explore_layer_toggle_click",
	},
	prioritize_slider: {
		event: "prioritize_slider",
		param: "prioritize_slider_click",
		transform: (value: any, sliderName: string) =>
			({
				LowIncPercRank: "income_slider",
				POCPercRank: "poc_slider",
				HeatRank: "heat_island_slider",
				RespRank: "air_pollution_slider",
				PPARank: "pop_density_slider",
				MentalRank: "mental_health_slider",
				LPARank: "physical_activity_slider",
			}[sliderName]),
	},
	prioritize_toggles: {
		event: "prioritize_toggles",
		param: "prioritize_toggles_click",
	},
	evaluate_draw: {
		event: "evaluate_draw",
		param: "evaluate_draw_end",
	},
	evaluate_analyze: {
		event: "evaluate_analyze",
		param: "evaluate_analyze_click",
	},
	evaluate_analyze_pdf: {
		event: "evaluate_analyze_pdf",
		param: "evaluate_analyze_download",
	},
	evaluate_analyze_time: {
		event: "evaluate_analyze_time",
		param: "evaluate_analyze_time_in_seconds",
	},
	/*
	evaluate_analyze_status: {
		event: "evaluate_analyze_status",
		param: "evaluate_analyze_status_result",
	},*/
	evaluate_analyze_status: {
		event: "evaluate_analyze_status",
		params: {
			evaluate_analyze_status_result: "evaluate_analyze_status_result",
			evaluate_analyze_status_time: "evaluate_analyze_status_time",
		}
	},
	basemap_toggle: {
		event: "basemap_toggle",
		param: "basemap_toggle_click",
	},
	park_reviewer: {
		event: "park_reviewer",
		params: {
			park_reviewer_click: "park_reviewer_click",
			park_reviewer_url: "park_reviewer_url",
		}
	},
};

const useAnalytics = () => {
	ReactGA.initialize(MEASUREMENT_ID);
	ReactGA.send({ hitType: "pageview", page: "entry", title: "Main Page" });
};

const trackEvent = (
	type: keyof typeof TRACKING_CONFIG,
	value?: any,
	secondaryValue?: any
) => {
	const config = TRACKING_CONFIG[type];
	if (!config) return;

	let eventData: Record<string, any> = {
		event: config.event,
	};

	if (config.params) {
		// Handle multiple parameters case
		if (typeof value === "object") {
			Object.entries(config.params).forEach(([key, paramName]) => {
				//console.log(value[key]);
				eventData[paramName] = value[key];
			});
		}
	} else {
		const paramValue = config.transform
			? config.transform(value, secondaryValue)
			: config.defaultValue || value;

		eventData[config.param] = paramValue;
	}
	console.log(eventData)
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(eventData);
};

const trackPageView = (page: string) => {
	ReactGA.send({ hitType: "pageview", page, title: page });
};

export { useAnalytics, trackEvent, trackPageView };
